import React from 'react';
import { Formik } from 'formik';
import { Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import BaseForm from './baseForm';
import DividerForm from '../../Forms/UI/DividerForm';
import { SaveBtn } from '../../Buttons';
import GestioneProcessoImprese from '../../../shared/services/rpc/gestione-processo-imprese';
import getErrors from '../../../shared/lib/geterrors';

export const mapToInitialValues = (newValues) => {
  const mappedValues = {
    motivo: newValues.motivo,
    nota: newValues.nota,
    soggettoId: newValues.soggettoId,
    allegatoId: newValues.allegatoId,
  };

  return mappedValues;
};

export class AnnullaProcessoImpresa extends React.Component {
  // eslint-disable-line

  constructor(props) {
    super(props);
    this.state = {
      id: '',
    };
  }

  onSubmit = () => {
    this.baseForm.submitForm();
  };

  onBaseSubmit = (values, actions) => {
    actions.setSubmitting(true);

    const payload = {
      ...values,
    };

    GestioneProcessoImprese.blocca(_.get(payload, 'motivo.value') || '', this.props.impresaId, payload.nota)
      .then(() => {
        this.props.notifications().addNotification({
          message: 'Pratica annullata',
          level: 'success',
        });
        this.props.update();
        this.props.close();
      })
      .catch((error) => {
        const errorsObj = getErrors(error);
        actions.setSubmitting(false);
        actions.setErrors(errorsObj);

        // Error notification
        this.props.notifications().addNotification({
          message:
            error.data.detail ||
            'Si è verificato un problema con il salvataggio del form, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  };

  render() {
    return (
      <Grid>
        <Grid.Column width={16}>
          <Formik
            ref={(c) => {
              this.baseForm = c;
            }}
            initialValues={this.props.initialValues ? this.props.initialValues : mapToInitialValues}
            onSubmit={this.onBaseSubmit}
            validate={() => {
              const errors = {};
              return errors;
            }}
            render={(props) => <BaseForm {...props} />}
          />
        </Grid.Column>
        <DividerForm />
        <Grid.Column width={8} textAlign="left">
          <Button onClick={this.props.close} type="button" icon="delete" labelPosition="right" content="Chiudi" />
        </Grid.Column>
        <Grid.Column width={8} textAlign="right">
          <SaveBtn action={this.onSubmit} />
        </Grid.Column>
      </Grid>
    );
  }
}

AnnullaProcessoImpresa.propTypes = {
  notifications: PropTypes.func,
  update: PropTypes.func,
  close: PropTypes.func,
  impresaId: PropTypes.string,
};

export default AnnullaProcessoImpresa;



// WEBPACK FOOTER //
// ./app/components/ProcessoImpresa/AnnullaPorcessoImpresa/index.js